import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function organizationListQueryOptions(params: ListParams) {
  return queryOptions({
    queryKey: organizationKeys.list(params),
    queryFn: () => organizationsApi.list(params),
    placeholderData: keepPreviousData,
  });
}

export function useOrganizations(params: ListParams) {
  return useQuery(organizationListQueryOptions(params));
}
